export default "__VITE_ASSET__a152e800__"